import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, CalendarClock, Pencil } from "lucide-react";
import { api, apiErr } from "../api";
import { PanelPage, Header, FullLoader, BrandLogo, prettyDate } from "../ui";
import ClinicalSlide from "../components/ClinicalSlide";
import { SPEC } from "../fields";
import NextAppointmentModal from "../components/NextAppointmentModal";

export default function Visor() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [appt, setAppt] = useState(false);
  const load = () => api.get(`/patients/${id}`).then((r) => setP(r.data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <PanelPage>
      <Header />
      <div className="pn-visor">
        {!p ? <FullLoader /> : (
          <main className="max-w-6xl mx-auto px-4 sm:px-8 py-8">
            <div className="flex flex-wrap items-center justify-between gap-3 mb-5 pn-noprint">
              <Link to={`/pacientes/${id}`} className="inline-flex items-center gap-1.5 text-sm text-white/60 hover:text-white"><ArrowLeft size={15} /> Ficha del paciente</Link>
              <div className="flex gap-2">
                <Link to={`/pacientes/${id}/editar`} className="pn-btn bg-white/10 text-white hover:bg-white/15"><Pencil size={15} /> Editar datos</Link>
                <button onClick={() => setAppt(true)} className="pn-btn pn-btn-primary"><CalendarClock size={15} /> ¿Cuándo será la próxima consulta?</button>
              </div>
            </div>
            <ClinicalSlide
              heading={`Caso ${p.nombre} · Fecha ${prettyDate(p.fecha_consulta)} · Consulta: ${p.consulta_lugar || "—"}`}
              title={p.titulo_diagnostico ? `Título: ${p.titulo_diagnostico}` : p.nombre}
              cuadro={p.cuadro_clinico}
              signs={SPEC.visor.signs.filter(([k]) => p[k]).map(([k, l]) => `${l} ${p[k]}`).join(" · ")}
              labs={[p.laboratorios, p.patologia && `Patología: ${p.patologia}`].filter(Boolean).join("\n\n")}
              labMedia={p.lab_media} ekgMedia={p.ekg_media} ecoMedia={p.eco_media}
              ecoText={[SPEC.visor.videoText, SPEC.visor.videoText2].filter((k) => k && p[k]).map((k) => p[k]).join("\n\n")}
              diagnosis={SPEC.visor.videoText2 ? p.plan_tratamiento : ""}
              labels={SPEC.visor}
              dateLabel={p.fecha_consulta ? prettyDate(p.fecha_consulta) : ""} />
            {p.next_appointment && <p className="text-center mt-6" style={{ color: "var(--accent)" }}>Próxima consulta: {prettyDate(p.next_appointment.fecha, true)}{p.next_appointment.hora ? ` · ${p.next_appointment.hora}` : ""}</p>}
            <div className="flex justify-center mt-10"><BrandLogo className="h-11" /></div>
          </main>
        )}
      </div>
      {appt && p && <NextAppointmentModal patient={p} onClose={() => setAppt(false)} onSaved={load} />}
    </PanelPage>
  );
}
